var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.messages.length > 0)?_vm._l((_vm.messages),function(message){return _c('message-item',{key:'msg_' + message.id,attrs:{"message":message}})}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }